import { Row, Col } from 'src/componentes/grid';
import { useIntl } from 'react-intl';
import ProcessoLookup from 'src/lookups/processo';
import { capitalizeFirstLetter } from 'src/utils/string';
import RiscoLookup from 'src/lookups/item';
import ColaboradorEGrupoSimplificadoLookup from 'src/lookups/ColaboradorEGrupoSimplificadoLookup';
import PeriodoData from 'src/paginas/data/periodo-data';
import ItemOrganizacaoLookup from 'src/lookups/item-organizacao';
import Checkbox from 'src/componentes/checkbox';
import Input from 'src/componentes/input';
import useAuth from 'src/hooks/useAuth';

const RevisoesGerenciarSearch = ({ model }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  const handleChangeFiltro = (field, value) => {
    model.getModel(field).requestChange(value);
  };

  return (
    <div>
      <Row>
        <Col md={12}>
          <Input
            model={{
              label: capitalizeFirstLetter(
                intl.formatMessage({ id: 'idIntegracao' })
              ),
              value: model.getModel('codigo').value,
              requestChange: model.getModel('codigo').requestChange,
            }}
          />
        </Col>
        <Col md={12}>
          <ItemOrganizacaoLookup
            multi={true}
            model={{
              label: capitalizeFirstLetter(resources.areas),
              value: model.getModel('areas').value,
              requestChange: model.getModel('areas').requestChange,
            }}
            data={{ tiposIdSelecionaveis: [1, 2, 3] }}
          />
          <Checkbox
            model={{
              label: intl.formatMessage(
                { id: 'label.considerarAreasSubordinadas' },
                { areas: resources.areas }
              ),
              value: model.getModel('areasSubordinadas').value,
              requestChange: model.getModel('areasSubordinadas').requestChange,
            }}
          />
        </Col>
        <Col md={12} className="mt-2">
          <RiscoLookup
            clearable
            data={{ tipoId: 6 }}
            model={{
              label: capitalizeFirstLetter(resources.risco),
              value: model.getModel('risco').value,
              requestChange: model.getModel('risco').requestChange,
            }}
          />
        </Col>
        <Col md={12}>
          <ProcessoLookup
            clearable
            useClickToOpen={false}
            multi
            model={{
              label: capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'label.processos' },
                  { processos: resources.processos }
                )
              ),
              value: model.getModel('processos').value,
              requestChange: model.getModel('processos').requestChange,
            }}
            data={{ TipoId: 5 }}
          />
        </Col>
        <Col md={12}>
          <Checkbox
            model={{
              label: capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'incluirSubprocessos' },
                  {
                    processosfilhosplural:
                      resources.processosfilhosplural.toLowerCase(),
                  }
                )
              ),
              value: model.getModel('incluirSubprocessos').value,
              requestChange: model.getModel('incluirSubprocessos')
                .requestChange,
            }}
          />
        </Col>
        <Col md={12} className="mt-2">
          <ColaboradorEGrupoSimplificadoLookup
            clearable
            abrirEmDrawer
            model={{
              label: capitalizeFirstLetter(resources.responsavel),
              value: model.getModel('responsavel').value,
              requestChange: model.getModel('responsavel').requestChange,
            }}
          />
        </Col>
        <Col md={12}>
          <PeriodoData
            clearable
            tipoFiltroData={model.getModel('tipoFiltroData').value}
            dataInicio={model.getModel('dataInicio').value}
            dataTermino={model.getModel('dataTermino').value}
            onChange={handleChangeFiltro}
            isDrawerFilter
          />
        </Col>
      </Row>
    </div>
  );
};

export default RevisoesGerenciarSearch;
